var map = {
	"./csv.svg": 1007,
	"./dat.svg": 1008,
	"./doc.svg": 1009,
	"./docx.svg": 1010,
	"./dog-paw.svg": 1011,
	"./download.svg": 322,
	"./ftp.svg": 1012,
	"./html.svg": 1013,
	"./img.svg": 1014,
	"./json.svg": 1015,
	"./log.svg": 1016,
	"./microphone.svg": 1017,
	"./mov.svg": 1018,
	"./msg.svg": 1019,
	"./nounDog1614015.svg": 1020,
	"./nounDog1614015Blue.svg": 1021,
	"./pbix.svg": 1022,
	"./pdf.svg": 1023,
	"./ps1.svg": 1024,
	"./rar.svg": 1025,
	"./sql.svg": 1026,
	"./svg.svg": 1027,
	"./txt.svg": 1028,
	"./unknown.svg": 321,
	"./xlsx.svg": 1029,
	"./xml.svg": 1030,
	"./zip.svg": 1031
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1006;